import * as Sentry from "@sentry/react";
import { BrowserRouter, Routes, Route } from "react-router";
import { HomePage, LogoutPage, SetPasswordPage } from "./pages";

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

function App() {
  return (
    <BrowserRouter>
      <SentryRoutes>
        <Route path="/" element={<HomePage />} />
        <Route path="/set-password" element={<SetPasswordPage />} />
        <Route path="/logout" element={<LogoutPage />} />
      </SentryRoutes>
    </BrowserRouter>
  );
}

export default App;
